import PricingSection from './../sections/PricingSection';
import HeroSection from './../sections/HeroSection';
import TestimonialsSection from './../sections/TestimonialsSection';
import HowItWorkSection from './../sections/HowItWorkSection';
import BlogSection from './../sections/BlogsSection';
import MainServiceSection from './../sections/MainServiceSection';
import AboutUs from './../sections/AboutUsSection';
import { Link } from 'react-router-dom';
import MainFAQ from './../sections/MainFaqSection';

function HomeScreen() {
  return (
        <>
        <HeroSection/>
        <AboutUs/>
        <div className="flex justify-center">
          <Link 
            to="about"
            onClick={() => window.scrollTo(0, 0)}
            className="bg-emerald-600 text-white px-6 py-3 rounded-xl hover:translate-y-1">
            Read More
          </Link>
        </div>
        <MainServiceSection/>
        <PricingSection/>
        <div className="flex mt-10 justify-center">
          <Link 
            to="pricing" 
            onClick={() => window.scrollTo(0, 0)}
            className="bg-emerald-600 text-white px-6 py-3 rounded-xl hover:translate-y-1">
            Read More
          </Link>
        </div>
        <br/><br/>
        <TestimonialsSection/>
        <HowItWorkSection/>
        <BlogSection/>
        <MainFAQ/>
    </>
  );
}

export default HomeScreen;
